import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { BookingHistoryService } from './booking-history.service';

@Component({
  selector: 'app-bookings-history',
  templateUrl: './bookings-history.component.html',
  styleUrls: ['./bookings-history.component.scss']
})
export class BookingsHistoryComponent implements OnInit {

  @Input() bookingId: any;
  @Input() miscelleneousConfig;
  @Output() handleCloseHistoryCallback = new EventEmitter();
  @Output() toggleLoadingCallBack = new EventEmitter();

  public historyInfoUnformatted: any;
  public historyDate: string;
  public historyInfo = [];

  dummyData = [
    {
      time: '01 Jan, 12:00:52.987 AM',
      activity: 'Booking created with id 132BHD03Y',
      details: 'Spot Transport (101)'
    },
    {
      time: '01 Jan, 12:00:52.987 AM',
      activity: 'Booking created with id 132BHD03Y',
      details: 'Spot Transport (101)'
    },
    {
      time: '01 Jan, 12:00:52.987 AM',
      activity: 'Booking created with id 132BHD03Y',
      details: 'Spot Transport (101)'
    }

  ];

  constructor(public utilService: UtilService, public bookingHistoryService: BookingHistoryService) { }

  ngOnInit() {
    this.getBookingHistory(this.bookingId);
  }

  getBookingHistory(bookingId: any) {
    const searchQuery = {
      bookingId
    };
    this.bookingHistoryService.fetchBookingHistory(searchQuery).subscribe((response) => {
      this.historyInfoUnformatted = response;
      this.formatBookingHistoryresponse();
    });

  }

  formatBookingHistoryresponse() {
    Object.keys(this.historyInfoUnformatted).forEach((historyDate: string) => {
      let arrayVal: any;
      Object.keys(this.historyInfoUnformatted[historyDate]).forEach((empNameAndId: string) => {
        arrayVal = {
          name: empNameAndId,
          date: this.utilService.getMoment(historyDate),
          info: this.historyInfoUnformatted[historyDate][empNameAndId]
        };
        this.historyInfo.push(arrayVal);

      });
    });
    if (this.toggleLoadingCallBack) {
      this.toggleLoadingCallBack.emit(false);
    }
  }

  getHistoryDate(historyItem: any) {
    return this.miscelleneousConfig['12hrTimeFormat'] === 'true' ?
      historyItem.history.date.format('DD/MM/YY hh:mm A') : historyItem.history.date.format('DD/MM/YY HH:mm');
  }

  handleCloseHistoryView() {
    if (this.handleCloseHistoryCallback) {
      this.handleCloseHistoryCallback.emit();
    }
  }

}
